/**
 * Tabbed Collection - Tab switching functionality
 * SEO-friendly: All content is server-rendered, JS only toggles visibility
 */

document.addEventListener('DOMContentLoaded', function () {
    initTabbedCollections();
});

function initTabbedCollections() {
    const sections = document.querySelectorAll('.tabbed-collection');

    sections.forEach(section => {
        const tabsContainer = section.querySelector('.tabbed-collection__tabs');
        const tabs = section.querySelectorAll('.tabbed-collection__tab');
        const panels = section.querySelectorAll('.tabbed-collection__panel');
        const prevBtn = section.querySelector('.tabbed-collection__nav--prev');
        const nextBtn = section.querySelector('.tabbed-collection__nav--next');

        if (!tabs.length || !panels.length) return;

        // Tab click handler
        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                const tabIndex = tab.dataset.tabIndex;
                activateTab(section, tabIndex, tabs, panels);
            });
        });

        // Keyboard navigation
        tabs.forEach((tab, index) => {
            tab.addEventListener('keydown', (e) => {
                let newIndex = index;

                if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
                    e.preventDefault();
                    newIndex = (index + 1) % tabs.length;
                } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
                    e.preventDefault();
                    newIndex = (index - 1 + tabs.length) % tabs.length;
                } else if (e.key === 'Home') {
                    e.preventDefault();
                    newIndex = 0;
                } else if (e.key === 'End') {
                    e.preventDefault();
                    newIndex = tabs.length - 1;
                }

                if (newIndex !== index) {
                    tabs[newIndex].focus();
                    tabs[newIndex].click();
                }
            });
        });

        // Navigation arrows for mobile
        if (prevBtn && nextBtn && tabsContainer) {
            prevBtn.addEventListener('click', () => {
                tabsContainer.scrollBy({ left: -150, behavior: 'smooth' });
            });

            nextBtn.addEventListener('click', () => {
                tabsContainer.scrollBy({ left: 150, behavior: 'smooth' });
            });

            // Update arrow visibility based on scroll position
            const updateArrows = () => {
                const { scrollLeft, scrollWidth, clientWidth } = tabsContainer;
                prevBtn.classList.toggle('hidden', scrollLeft <= 0);
                nextBtn.classList.toggle('hidden', scrollLeft >= scrollWidth - clientWidth - 5);
            };

            tabsContainer.addEventListener('scroll', updateArrows);
            window.addEventListener('resize', updateArrows);
            updateArrows();
        }
    });
}

function activateTab(section, tabIndex, tabs, panels) {
    // Update tabs
    tabs.forEach(tab => {
        const isActive = tab.dataset.tabIndex === tabIndex;
        tab.classList.toggle('active', isActive);
        tab.setAttribute('aria-selected', isActive);
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    // Update panels
    panels.forEach(panel => {
        const isActive = panel.dataset.tabIndex === tabIndex;
        panel.classList.toggle('active', isActive);
        panel.hidden = !isActive;
    });

    // Update header view all links
    const viewAllLinks = section.querySelectorAll('.tabbed-collection__header-view-all .link');
    if (viewAllLinks.length > 0) {
        viewAllLinks.forEach(link => {
            const isLinkActive = link.dataset.tabIndex === tabIndex;
            link.classList.toggle('hidden', !isLinkActive);
        });
    }

    // Scroll active tab into view on mobile
    const activeTab = section.querySelector('.tabbed-collection__tab.active');
    if (activeTab) {
        activeTab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
}

// Re-initialize on Shopify section load (for theme editor)
if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
        if (event.target.querySelector('.tabbed-collection')) {
            initTabbedCollections();
        }
    });
}
